var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"brand-icon",attrs:{"src":_vm.iconUrl,"alt":_vm.alt},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }